import { discountedExclVat, pickDisplayPair } from "~/lib/sale-engine";

type ResolveDisplayUnitPricesArgs = {
  showPricesInclVat: boolean;
  unitPriceExclVat: number;
  unitPriceInclVat: number;
  discountedUnitPriceInclVat: number;
};

/**
 * Pick the display basis for a product card. Discounts are detected and
 * applied on the incl-VAT basis; the excl display scales the excl base by the
 * same factor.
 */
export function resolveDisplayUnitPrices({
  showPricesInclVat,
  unitPriceExclVat,
  unitPriceInclVat,
  discountedUnitPriceInclVat
}: ResolveDisplayUnitPricesArgs): {
  unitDisplayPrice: number;
  unitDisplayListPrice: number | null;
} {
  const { price, list } = pickDisplayPair({
    showPricesInclVat,
    priceInclVat: discountedUnitPriceInclVat,
    priceExclVat: discountedExclVat(
      unitPriceExclVat,
      discountedUnitPriceInclVat,
      unitPriceInclVat
    ),
    listInclVat: unitPriceInclVat,
    listExclVat: unitPriceExclVat
  });

  return { unitDisplayPrice: price, unitDisplayListPrice: list };
}

type ResolveDisplayLineTotalsArgs = {
  showPricesInclVat: boolean;
  unitTotalPriceInclVat: number;
  unitTotalListPriceInclVat: number | null;
  unitTotalPriceExclVat: number;
  unitTotalListPriceExclVat: number | null;
};

/**
 * Pick the display basis for a basket line. Excl totals are rounded per line
 * so the lines sum to the excl subtotal.
 */
export function resolveDisplayLineTotals({
  showPricesInclVat,
  unitTotalPriceInclVat,
  unitTotalListPriceInclVat,
  unitTotalPriceExclVat,
  unitTotalListPriceExclVat
}: ResolveDisplayLineTotalsArgs): {
  displayLineTotal: number;
  displayLineListTotal: number | null;
} {
  const { price, list } = pickDisplayPair({
    showPricesInclVat,
    priceInclVat: unitTotalPriceInclVat,
    priceExclVat: unitTotalPriceExclVat,
    listInclVat: unitTotalListPriceInclVat,
    listExclVat: unitTotalListPriceExclVat
  });

  return { displayLineTotal: price, displayLineListTotal: list };
}
